export default "__VITE_ASSET__B2qxEnY4__"